/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './InsetRow.styles.scss';

import { Grid, Cell } from './Grid';

const InsetRow = (props) => (
  <div className={classnames('cmp-insetrow', props.className)} style={props.style}>
    <Grid style={props.flexStyle}>
      <div className="left-side">
        {props.icon}
      </div>
      <Cell minWidth={100}>
        {props.children}
      </Cell>
    </Grid>
  </div>
);

InsetRow.propTypes = {
  icon: PropTypes.element,
  children: PropTypes.any,
  style: PropTypes.object,
  flexStyle: PropTypes.object,
  className: PropTypes.string,
};

InsetRow.defaultProps = {
  flexStyle: { alignItems: 'center' },
};

export default InsetRow;
